module.exports = __webpack_public_path__ + "static/media/80S Musician.6d8b1082.jpg";